import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/remessaController');

export default class RemessaCessaoService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async buscarOperacoesRemessa(idCessao: number) {
    return await this.axios.get(`/buscaRemessas/${idCessao}`);
  }

  async buscarRemessasPaginadas(page: number = 0, size: number = 10, sort: string = 'dtaCriacao,desc') {
    return await this.axios.get(`/listarRemessas?page=${page}&size=${size}&sort=${sort}`);
  }

}